import { pageSelectorGenerator } from '@test/pageSelectors';

export const GifterDetailsSelectors = pageSelectorGenerator('GifterDetails', ['ContainerElement', 'EmailInput', 'NameInput', 'NoteInput', 'SubmitButton']);
